<template>
  <div class="horizontal-list" ref="container">
    <div class="btn btn-left" v-if="hasPrev" @click="prev">
      <div id="left-button">
        <i class="fa fa-chevron-left t-secondary"></i>
      </div>
    </div>
    <div class="horizontal-list--items" ref="list">
       <div v-for="(item, i) in items" :key="i" class="item">
          <slot v-bind:item="item">{{ item }}</slot>
        </div>
    </div>
    <div class="btn btn-right" v-if="!isScrolledToEnd" @click="next">
      <div id="right-button">
        <i class="fa fa-chevron-right t-secondary"></i>
      </div>
    </div>
  </div>
</template>

<script>
import MPService from '@/services/mixpanel'

export default {
  name: 'horizontalList',
  props: {
    hasTrackers: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    offset: {
      type: Number,
      required: false,
      default: 260
    }
  },
  data () {
    return {
      isScrolledToEnd: false,
      stepPosition: 0,
      width: {
        container: 0,
        scrollWidth: 1
      }
    }
  },
  mounted () {
    this.$resize = () => {
      this.width.container = this.$refs.container.clientWidth
      this.width.scrollWidth = this.$refs.list.scrollWidth
    }

    this.$resize()
    window.addEventListener('resize', this.$resize)
  },
  computed: {
    workingWidth () {
      return this.width.container - this.offset
    },
    hasPrev () {
      return this.stepPosition > 0
    }
  },
  methods: {
    go (direction) {
      this.stepPosition += direction
      let scrollLeft = this.isScrolledToEnd
        ? this.width.scrollWidth - (this.workingWidth * 2)
        : this.workingWidth * this.stepPosition

      if (scrollLeft + this.workingWidth > (this.width.scrollWidth - this.offset)) {
        this.isScrolledToEnd = true
        scrollLeft = this.width.scrollWidth
        this.stepPosition -= 1
      } else {
        this.isScrolledToEnd = false
      }

      this.$refs.list.scrollTo({ top: 0, left: scrollLeft, behavior: 'smooth' })
    },
    prev () {
      if (this.hasTrackers) MPService.trackEvent('term_suggestions', { type: 'Previous' })

      this.go(-1)
    },
    next () {
      if (this.hasTrackers) MPService.trackEvent('term_suggestions', { type: 'Next' })

      this.go(1)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$resize)
  }
}
</script>
